module.exports = __webpack_public_path__ + "static/media/SB.b9da4b33.svg";